import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Component that alerts if you click outside of it
 */
export default class OutsideHandlerClick extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(evt) {
    const { handleClickOutside } = this.props;
    if (this.wrapperRef && !this.wrapperRef.contains(evt.target)) {
      if (handleClickOutside) {
        handleClickOutside(evt, this.wrapperRef);
      }
    }
  }

  render() {
    const { children, cClassName, fnHandleRef } = this.props;
    if (fnHandleRef) {
      fnHandleRef(this.wrapperRef);
    }
    return <div className={cClassName} ref={this.setWrapperRef}>{children}</div>;
  }
}

OutsideHandlerClick.propTypes = {
  children: PropTypes.element.isRequired,
  cClassName: PropTypes.string,
};
